import { render, staticRenderFns } from "./outsource-lawsuit-manage.vue?vue&type=template&id=3d4fa93d"
import script from "./outsource-lawsuit-manage.vue?vue&type=script&lang=ts"
export * from "./outsource-lawsuit-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports